export const MODIFY_SUBSCRIPTION_INFO = 'MODIFY_SUBSCRIPTION_INFO';

export function modifySubscriptionInfo(subscriptionInfo){
    return{
        type: MODIFY_SUBSCRIPTION_INFO,
        mainState: {
            subscriptionInfo: subscriptionInfo
        }
    }
}